import type { RouteRecordRaw } from 'vue-router'

import { ROUTES } from '~/scopes/auth/route-names'

import { CHECKOUT_BOUYGUES_IN_STORE } from './route-names'

const routes: RouteRecordRaw[] = [
  {
    path: 'checkout/in-store/bouygues-telecom/error',
    name: CHECKOUT_BOUYGUES_IN_STORE.BOUYGUES_TELECOM.ERROR,
    component: () =>
      import('./components/BouyguesMagicLinkError/BouyguesMagicLinkError.vue'),
    meta: {
      owners: ['bot-squad-b2cservices-front'],
      layout: false,
    },
  },
  {
    path: 'checkout/in-store/bouygues-telecom/:magicLinkId',
    name: CHECKOUT_BOUYGUES_IN_STORE.BOUYGUES_TELECOM.SELF,
    redirect: { name: CHECKOUT_BOUYGUES_IN_STORE.BOUYGUES_TELECOM.CART },
    component: () =>
      import('./layout/BouyguesMagicLinkLayout/BouyguesMagicLinkLayout.vue'),
    meta: {
      owners: ['bot-squad-b2cservices-front'],
      layout: false,
    },
    children: [
      {
        path: 'cart',
        name: CHECKOUT_BOUYGUES_IN_STORE.BOUYGUES_TELECOM.CART,
        component: () => import('./pages/CartStep/CartStep.vue'),
      },
      {
        path: 'address-edition',
        name: CHECKOUT_BOUYGUES_IN_STORE.BOUYGUES_TELECOM.ADDRESSES,
        component: () => import('./pages/AddressesStep/AddressesStep.vue'),
      },
      {
        path: 'payment',
        name: CHECKOUT_BOUYGUES_IN_STORE.BOUYGUES_TELECOM.PAYMENT,
        component: () => import('./pages/PaymentStep/PaymentStep.vue'),
      },
    ],
  },
  {
    path: 'checkout/in-store/bouygues-telecom/:magicLinkId/payment-result/:paymentId?',
    name: CHECKOUT_BOUYGUES_IN_STORE.BOUYGUES_TELECOM.PAYMENT_RESULT,
    component: () => import('../../pages/Result/Result.vue'),
    meta: {
      owners: ['bot-squad-checkout-front'],
      auth: {
        required: true,
        redirection: { name: ROUTES.AUTH.LOGIN },
      },
    },
  },
]

export default routes
